<template>
	<mu-col :span="12" :lg="6" class="bus-layout-container py-2">
        <mu-row gutter class="bus-layout">
        	<mu-col :span="12" v-style_header="{ background_color: color, t_color: title_color, t_align: title_align}" class="bus-header">
                <span v-text-size="{t_size: title_size}"> {{ title }} </span> <br>
                <span v-text-size="{t_size: (title_size * .67)}" v-html="subtitle"></span>
            </mu-col>

            <mu-row gutter justify-content="center" align-items="center" v-for="(floor, i_floor) in seats_template" :key="i_floor" class="bus-content">
                <template v-for="(seat, i_seat) in floor">
                    <div v-if="seat.type !== 'empty'" :key="i_seat" :class="(seat.type === 'hallway') ? 'slot-hallway' : (seat.type === 'women_bathroom' || seat.type === 'men_bathroom') ? 'slot-bathroom' : 'slot-seat'">
                        <!-- <- SEAT -> -->
                        <span @click="selectSeat(seat.seat)" v-if="seat.type === 'seat'">

                            <template v-if="seat.occupation.length === 0">
                                <img :src="(seats_selected.indexOf(seat.seat) == -1) ? seat_available : seat_selected" alt="available">
                            </template>
                            <template v-else-if="seat.occupation.length > 0">
                                <template v-for="(key, index) of seat.occupation" >

                                    <img :src="seat_block_reserved" alt="block-reserved" :key="index" :ref="seat.seat">

                                    <!--                                     
                                    <img :src="seat_block_reserved" alt="block-reserved" :key="index" v-if="key.origin < destination && origin < key.destination" :ref="seat.seat">
                                    <img :src="seat_block_reserved" alt="block-reserved" :key="index" v-else-if="key.origin > destination && origin > key.destination" :ref="seat.seat">
                                    <img :src="seat_block_reserved" alt="block-reserved" :key="index" v-else-if="key.origin === origin && destination === key.destination" :ref="seat.seat">
                                     -->
                                    

                                    <!-- <img :src="seat_block_reserved" alt="block-reserved" :key="index" v-if="origin >= key.destination " :ref="seat.seat">
                                    <img :src="seat_block_reserved" alt="block-reserved" :key="index" v-else-if="key.origin <= destination " :ref="seat.seat">
                                    <img :src="(seats_selected.indexOf(seat.seat) == -1) ? seat_available : seat_selected" alt="available" :key="index" v-else> -->
                                </template>
                            </template>
                            <template v-else>
                                <img :src="seat_block_reserved" alt="block-reserved">
                            </template>

                           

                            <p class="number_seat">{{ seat.seat }}</p>
                        </span>
                        <!-- <- WOMEN RESTROOM -> -->
                        <span v-else-if="seat.type === 'women_bathroom'">
                            <div class="women">
                                <img :src="bath_female" alt="wc-women">
                            </div>
                        </span>
                        <!-- <- MEN RESTROOM -> -->
                        <span v-else-if="seat.type === 'men_bathroom'">
                            <div class="men">
                                <img :src="bath_male" alt="wc-men">
                            </div>
                        </span>
                    </div>
                </template>
            </mu-row>
        </mu-row>
    </mu-col>
</template>

<script>
    //HELPERS
    import _GlobalHelper from '@/store/helpers/global'
    import _BusLayoutHelper from '@/store/helpers/busLayout/buslayout'
    //IMAGES
    import driver_b from '@@/images/reservation/driver.png'
    import seat_available from '@@/images/reservation/available.png'
    import seat_selected from '@@/images/reservation/reserved.png'
    import seat_block_reserved from '@@/images/reservation/block.png'
    import bath_female from '@@/images/reservation/bathroom_women.png'
    import bath_male from '@@/images/reservation/bathroom_men.png'
    // VUEX
    import { mapActions, mapGetters, mapMutations } from 'vuex'

		export default {
        name: 'bus-layout',
		data() {
			return {
                // Images
                seat_available: seat_available,
                seat_selected: seat_selected,
                seat_block_reserved: seat_block_reserved,
                bath_female: bath_female,
                bath_male: bath_male,
                // Seats
                seat_pivot: 0,
                seats_selected: []
			}
		},
        props: {
            origin: {
                require: false,
                type: Number
            },
            destination: {
                require: false,
                type: Number
            },
            color: {
                require: false,
                default: '#005296'
            },
            title: {
                required: false,
                type: String,
                default: 'DEFAULT TITLE'
            },
            subtitle: {
                required: false,
                type: String,
                default: 'Default Subtitle'
            },
            title_color: {
                require: false,
                default: 'white'
            },
            title_size: {
                require: false,
                type: Number,
                default: 24
            },
            title_align: {
                require: false,
                type: String,
                default: 'center',
                validator: function (value) {
                    // El valor debe coincidir con una de estas cadenas de texto
                    return ['left', 'right', 'center'].indexOf(value) !== -1
                }
            },
            passengers: {
                required: true,
                type: Number
            },
            round: {
                require: false,
                type: Boolean,
                default: false
            },
            seats_template: {
                require: true,
                type: Object,
            }
        },
        directives: {
            'style_header': {
                bind(el, binding, vnode) {
                    el.style.backgroundColor = binding.value.background_color
                    el.style.color = binding.value.t_color
                    el.style.textAlign = binding.value.t_align
                },
            },
            'text-size': {
                bind(el, binding, vnode) {
                    if(binding.value.t_size != 0) {
                        el.style.fontSize = binding.value.t_size.toString() + "px"
                    }
                },
            }
        },
        model: {
            prop: 'value',
            event: 'change'
        },
        methods: {
            ...mapMutations({
                set_alert: _GlobalHelper.mutations.alert,
                set_loading: _GlobalHelper.mutations.loading
            }),
            ...mapActions({
                change: _BusLayoutHelper.actions.change_seats_selected
            }),

            selectSeat(seat_number) {

                if(this.$refs[seat_number] !== undefined) {
                    return
                }

                // Search if seat was previously selected
                if(this.seats_selected.indexOf(seat_number) == -1) {
                    // Search spaces with value null for insert new value
                    if(this.seats_selected.indexOf(null) >= 0) { 
                        this.seats_selected.splice(this.seats_selected.indexOf(null), 1, seat_number)
                        
                    }
                    // If not was preeviously selected and seats selected is smaller than total passenger
                    else if(this.seats_selected.length < this.passengers) {
                        // Add to finally to array the new number seat
                        this.seats_selected.push(seat_number)
                        this.changeSeatPivot()
                    }
                    // If total selected seats is equal to total passenger
                    else if(this.seats_selected.length = this.passengers) {
                        this.$set(this.seats_selected, this.seat_pivot, seat_number)
                        this.changeSeatPivot()
                    }
                }
                else {
                    // Search the index of seat to remove
                    for(let i in this.seats_selected) {
                        if(this.seats_selected[i] == seat_number) {
                            this.seats_selected.splice(i, 1)
                        }
                    }
                }
                // CAMBIARLO POR VUEX
                //this.$emit('change', this.seats_selected)
                this.changeSeatsSelected()

            },
            changeSeatPivot() {
                if(this.seat_pivot < this.passengers - 1) {
                    this.seat_pivot ++
                }
                else {
                    this.seat_pivot = 0
                }
                // console.log(this.seat_pivot)
            },
            changeSeatsSelected() {
                this.change({
                    return: this.round,
                    seats_selected: this.seats_selected
                })
            }
        },
        created() {
            //console.log('asientos', this.seats_template)
        }
	}
</script>

<style lang="scss">
    .bus-layout-container {
        .bus-layout {
            text-align: center;
            margin-left: auto;
            margin-right: auto;
            -webkit-border-radius: 8px;
            -moz-border-radius: 8px;
            -ms-border-radius: 8px;
            border-radius: 8px;
            width: 260px;
            height: auto;
            font-size: 16px;
            background-color: #e6e6e6;
            padding: 0px;
            box-sizing: content-box;
            overflow: hidden;

            .bus-header {
                padding: 10px;
            }

            .bus-content {
                margin: 10px 10px;

                span:hover {
                    cursor: pointer;
                }

                .number_seat {
                    color: white;
                    font-size: 20px;
                    margin-top: -40px;
                }
                
                .slot-seat {
                    width: 22%;
                }

                .slot-hallway {
                    background-color: #ccc !important;
                    width: 12%; 
                    height: 46px;
                }

                .slot-bathroom {
                    width: 44%;
                    padding: 0px 14px;

                    .women, .men {
                        border-radius: 8px;
                        padding: 3px;
                        height: 46px;

                        img {
                            max-width: 100%;
                            height: 40px;
                            display: block;
                            margin: auto;
                        }    
                    }

                    .women {
                        background-color: #ff80ab; 
                        border: 1px solid black;
                        //border: 1px solid #ff60ab;
                    }

                    .men {
                        background-color: #82b1ff;
                        border: 1px solid black;
                        //border: 1px solid #52a1ff;
                    }
                }
            }
        }
    }

</style>